export default __webpack_public_path__ + "static/media/Motor.42f4375b.svg";